/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Publicname1Inputs */

const de__field_publicname1 = /** @type {(inputs: _Field_Publicname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`öffentlicher Name`)
};

/**

* @param {_Field_Publicname1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_publicname1 = /** @type {((inputs?: _Field_Publicname1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Publicname1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_publicname1(inputs)
});
export { _field_publicname1 as "_field_publicName" }